import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const companyData = [
  { label: '会社名', value: '株式会社Ｓ．Ａ．Ｓｅｃｕｒｉｔｙ （エスエーセキュリティ）' },
  { label: '所在地', value: '〒102-0083　東京都千代田区麹町2-2-22ACN半蔵門ビル10階' },
  { label: '代表者', value: '代表取締役　河野 光輝' },
  { label: '設立', value: '2023年9月' },
  { label: '資本金', value: '800万円' },
  { label: '警備業認定番号', value: '東京都公安委員会　第30004873号' },
  { label: '対応エリア', value: '東京23区内、および近隣市部（詳細はお問い合わせください）' },
  { label: '営業時間', value: '24時間・365日対応（緊急時も即時対応）' },
  { label: '主な業務内容', value: '交通誘導警備・雑踏警備' },
  { label: '従業員数', value: '30名' },
];

const BADGE_IMAGE = "https://storage.readdy-site.link/project_files/77b0cd95-ed89-4a21-83d0-e55047076128/bb548e9f-bca0-4376-abf5-bb7a08122ea9_SAS_HPpng.png?v=f6a0fd53700e749e855ec90ef41ea651";

export default function CompanyInfo() {
  const { ref, isVisible } = useScrollAnimation();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section id="company" className="py-24 bg-[#f4f7fb]">
      <div className="max-w-4xl mx-auto px-6">
        <div ref={ref} className={`fade-in-up ${isVisible ? 'visible' : ''}`}>
          <div className="text-center mb-12">
            <span className="text-[#38BDF8] text-sm font-medium tracking-widest">COMPANY</span>
            <h2 className="text-[#0D1A4E] text-3xl md:text-4xl font-black mt-3 mb-4">会社概要</h2>
            <div className="w-12 h-1 bg-[#38BDF8] mx-auto"></div>
          </div>

          <div className="bg-white border border-gray-100 rounded-lg overflow-hidden">
            {companyData.map((item, idx) => (
              <div
                key={idx}
                className={`flex ${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'} border-b border-gray-100 last:border-b-0`}
              >
                <div className="w-44 min-w-[176px] px-6 py-4 bg-[#0D1A4E]/[0.03] border-r border-gray-100 flex items-center">
                  <span className="text-[#0D1A4E] text-sm font-bold">{item.label}</span>
                </div>
                <div className="flex-1 px-6 py-4 flex items-center">
                  <span className="text-gray-700 text-sm leading-relaxed">{item.value}</span>
                </div>
              </div>
            ))}
          </div>

          {/* 警備業者標識 */}
          <div className="mt-8 bg-white border border-gray-100 rounded-lg overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-award-line text-[#38BDF8] text-base"></i>
              </div>
              <span className="text-[#0D1A4E] text-sm font-bold">警備業者標識</span>
            </div>
            <div className="p-6 flex flex-col sm:flex-row items-center gap-6">
              <div
                className="w-64 h-56 flex-shrink-0 rounded-md overflow-hidden border border-gray-100 cursor-pointer relative group"
                onClick={() => setModalOpen(true)}
              >
                <img
                  src={BADGE_IMAGE}
                  alt="警備業標識"
                  className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/80 rounded-full w-10 h-10 flex items-center justify-center">
                    <i className="ri-zoom-in-line text-[#0D1A4E] text-lg"></i>
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <p className="text-[#0D1A4E] font-bold text-sm mb-2">東京都公安委員会　認定標識</p>
                <p className="text-gray-600 text-xs leading-relaxed mb-4">
                  警備業法第11条の規定に基づき、営業所ごとに警備業標識を掲示しています。
                  当社は東京都公安委員会より正式に認定を受けた適正な警備事業者です。
                </p>
                <div className="bg-[#f4f7fb] rounded-md px-4 py-3">
                  <p className="text-[#0D1A4E] text-xs font-bold">認定番号</p>
                  <p className="text-[#38BDF8] text-sm font-black mt-0.5">東京都公安委員会　第30004873号</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 border border-[#38BDF8]/30 bg-[#38BDF8]/5 rounded-lg p-6 flex gap-4">
            <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-star-line text-[#38BDF8] text-2xl"></i>
            </div>
            <div>
              <p className="text-[#0D1A4E] font-bold text-sm mb-1">成長を続ける、信頼できる警備会社</p>
              <p className="text-gray-600 text-xs leading-relaxed">
                都道府県公安委員会より警備業の認定を受けた適正事業者として、設立初日から法令遵守を徹底。
                小規模の今だからこそ、一現場一現場を大切に。この積み重ねが、私たちのさらなる成長を支えています。
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {modalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70"
          onClick={() => setModalOpen(false)}
        >
          <div
            className="relative max-w-2xl w-full mx-4 bg-white rounded-xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full cursor-pointer transition-colors duration-200 z-10"
              onClick={() => setModalOpen(false)}
            >
              <i className="ri-close-line text-[#0D1A4E] text-xl"></i>
            </button>
            <div className="p-6 pt-8">
              <p className="text-center text-[#0D1A4E] text-sm font-bold mb-4">警備業者標識</p>
              <img
                src={BADGE_IMAGE}
                alt="警備業標識（拡大）"
                className="w-full h-auto object-contain max-h-[70vh]"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
